import { Link } from 'react-router-dom';
import PrivacyPolicyContent from './PrivacyPolicyContent.js';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-page__shell">
        <Link to="/login" className="legal-page__back">
          ← Back
        </Link>

        <h1>Privacy Policy</h1>
        <p className="legal-page__updated">Last updated: September 30, 2026</p>

        <PrivacyPolicyContent />
      </div>
    </div>
  );
}
